<template>
    <div>
        <template v-if="!isChange">
        <div class="l-element is-pdt0">
            <list-text :comments="true" class="is-mgt8">
                <li class="m-list-text-item">本キャンペーンのために当社が取得した情報に関し、本ページに記載のない点についてはピクトリンクのサービスプライバシーポリシーに準じて取り扱います。</li>
            </list-text>
            <list-text :comments="true" :none="true" class="is-mgt4">
                <li class="m-list-text-item">※なお、サービスプライバシーポリシーは随時改定されることがあります。</li>
            </list-text>
        </div>
        <div class="l-element">
            <div class="l-element c-panel-primary">
                <div class="l-element is-pdb0 c-heading-appeal-wrap">
                    <heading-appeal-primary text="安心してね！"/>
                    <img class="c-illust-girl-img" :src="buildImageUrl('certificate_illust_girl_2026.svg')" alt="女の子のイラスト">
                </div>
                <hr class="c-panel-primary-line">
                <div class="l-element">
                    <p class="m-text-normal is-mgb0 is-primary">
                        本人確認書類記載の情報は本サービスの年齢確認にのみ利用し、それ以外の目的で利用されることは絶対にありません。<br>
                        撮影画像は年齢確認完了後、当社プライバシーポリシーに定める期間内に責任をもって削除します。
                    </p>
                </div>
                <div class="l-element is-pdy0">
                    <p class="m-text-normal is-primary is-text-right c-panel-primary-arrow">
                        <link-text :link="servicePolicyUrl" :new-window="true" text="プライバシーポリシー" data-jest="privacy-policy-link"/>
                    </p>
                </div>
            </div>
        </div>
        </template>

        <section>
            <div class="l-element">
                <p class="m-text-normal is-mgb0 is-primary is-text-center is-text-bold">下記項目が記載されている書類の原本<br>（コピーは不可）をご準備ください。</p>
            </div>
            <div class="l-element">
                <div class="c-gray-panel">
                    <ol>
                        <li class="m-text-normal is-text-bold"><p>申込者本人の名前</p></li>
                        <li class="m-text-normal is-text-bold is-mgb0">
                            <p class="is-mgb4">現在中学生であることが証明できる下記の項目が記載されているもの</p>
                            <list-text>
                                <li class="m-list-text-item">生年月日</li>
                                <li class="m-list-text-item">学年</li>
                                <li class="m-list-text-item">書類の発行年や有効期限</li>
                                <li class="m-list-text-item">学校名/学校印</li>
                            </list-text>
                        </li>
                    </ol>
                    <p class="m-text-normal is-caution c-gray-panel-caution is-mgb0"><span class="is-caution">※</span>上記の情報が記載されている本人確認書類をご提出頂いても審査で利用不可、再申込になる場合があります。</p>
                </div>
            </div>
            <div class="l-element">
                <p class="m-text-normal is-mgb0 is-primary is-text-center is-text-bold">必要な情報が表と裏や、別ページにまたがる場合は<br>両方撮影してください。</p>
            </div>

            <div class="is-pdb8" data-jest="jhs-free-form-upload-school-issued">
                <form-input-certificate form-id="school-issued-front" key="school-issued-front" class="is-mgb8"
                                        :example-image-url="schoolIssuedFrontExampleImageUrl"
                                        button-text="表(おもて)を撮影する"
                                        :initial-photo-file="fileCertificateSchoolIssuedFront"
                                        :is-display="true"
                                        :camera-permitted="cameraPermitted"
                                        @input="updateFileCertificateSchoolIssuedFront" @delete="updateFileCertificateSchoolIssuedFront"
                                        data-jest="jhs-free-form-upload-school-issued-front"/>
                <form-input-certificate form-id="school-issued-back" key="school-issued-back"
                                        :example-image-url="schoolIssuedBackExampleImageUrl"
                                        button-text="はい(裏や別ページを撮影する)" :priority="cssPriority.SECONDARY"
                                        :initial-photo-file="fileCertificateSchoolIssuedBack"
                                        :is-display="true"
                                        :camera-permitted="cameraPermitted"
                                        @input="updateFileCertificateSchoolIssuedBack" @delete="updateFileCertificateSchoolIssuedBack"
                                        data-jest="jhs-free-form-upload-school-issued-back">
                    <div class="l-element">
                        <p class="m-text-normal is-mgb4">必要な情報が裏や別ページにありますか？</p>
                        <list-text :comments="true" :caution="true" :none="true">
                            <li class="m-list-text-item">※ない場合は撮影しないで下さい。</li>
                        </list-text>
                    </div>
                </form-input-certificate>
            </div>
        </section>

        <div class="l-section" data-jest="jhs-free-form-upload-checklist">
            <heading-bg title="必要な情報の確認"/>
            <div class="l-element">
                <div class="l-element c-panel-primary">
                    <div class="l-element is-pdb0 c-heading-appeal-wrap">
                        <heading-appeal-primary text="確認してね！"/>
                        <img class="c-illust-girl-img" :src="buildImageUrl('certificate_illust_girl_2026.svg')" alt="女の子のイラスト">
                    </div>
                    <hr class="c-panel-primary-line">
                    <div class="l-element">
                        <p class="m-text-normal is-mgb0 is-primary is-text-center">
                            撮影画像に不備がある場合、審査ができなくなり<br/>
                            サービスが利用できない可能性があります
                        </p>
                    </div>
                </div>
            </div>
            <div class="l-element">
                <p class="m-text-normal is-mgb0">下記の情報が鮮明に写っているかご確認いただき、全てをチェックしたら次に進んでください。</p>
            </div>
            <div v-for="(item, index) in checkboxItemList" class="l-element" :key="`checklist-next_${index}`" data-jest="jhs-free-form-check-list">
                <form-checkbox :label="item" :name="`check_photo_${index}`" :is-default-checked="checkboxResult[index]" v-model="checkboxResult[index]"/>
            </div>
            <div class="l-element is-pdt0">
                <list-text :caution="true" :comments="true" :none="true">
                    <li class="m-list-text-item">※チェックを入れてください</li>
                </list-text>
            </div>
        </div>
        <input type="hidden" id="cameraPermitted" value="true">

    </div>
</template>

<script>
import ListText from "../atoms/ListText.vue";
import LinkText from "../atoms/LinkText.vue";
import HeadingBg from "../atoms/HeadingBg.vue";
import HeadingAppealPrimary from "../atoms/HeadingAppealPrimary.vue";
import HeadingFormLabel from "../atoms/HeadingFormLabel.vue";
import Table from "../atoms/Table.vue"
import ListFormRadio from "../molecules/ListFormRadio.vue";
import FormCheckbox from "../atoms/FormCheckbox.vue";
import FormInputCertificate from "../molecules/FormInputCertificate.vue";
import {cssPriority} from "../../view-model/enum/CSSPriority";
import {mapActions, mapGetters} from "vuex";
import * as privacyPolicyAgreementAction from "../../model/action/PrivacyPolicyAgreementAction.js";
import * as urlUtil from "../../util/UrlUtil";

export default {
    name: "JhsFreeFormUploadCertificate",
    components: {
        HeadingBg,
        ListText,
        LinkText,
        Table,
        HeadingAppealPrimary,
        HeadingFormLabel,
        ListFormRadio,
        FormCheckbox,
        FormInputCertificate
    },
    emits: ['isCompleteFormInput'],
    props: {
        isChange: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cssPriority: cssPriority,
            radioResult: null,
            checkboxResult: [false, false],
            checkboxItemList: ['自分の名前', '書類の全面が写っている'],
            servicePolicyUrl: null,
            cameraPermitted: true,
        }
    },
    computed: {
        ...mapGetters('JhsFreeStore', [
            'fileCertificateSchoolIssuedFront', 'fileCertificateSchoolIssuedBack'
        ]),
        existsFileCertificate() {
            //写真が最低限1枚は撮影されていることを確認
            return this.fileCertificateSchoolIssuedFront != null
        },
        isCheckedAllCheckList() {
            return !this.checkboxResult.includes(false)
        },
        isCompleteFormInput() {
            return this.existsFileCertificate && this.isCheckedAllCheckList
        },
        schoolIssuedFrontExampleImageUrl() {
            return this.buildImageUrl('school_issued_id_front_2026.png')
        },
        schoolIssuedBackExampleImageUrl() {
            return this.buildImageUrl('school_issued_id_back_2026.png')
        },
    },
    watch: {
        isCompleteFormInput: {
            handler(val) {
                this.updateIsCompleteFormInput(val)
            },
            immediate: true
        },
    },
    mounted() {
        this.setServicePolicyUrl()
        window.webkit?.messageHandlers?.setupCamera?.postMessage('setupCamera');
        this.cameraPermitted = document.getElementById('cameraPermitted').value === 'true';
    },
    methods: {
        ...mapActions('JhsFreeStore', [
            'updateFileCertificateSchoolIssuedFront', 'updateFileCertificateSchoolIssuedBack'
        ]),
        updateIsCompleteFormInput(value) {
            this.$emit('isCompleteFormInput', value);
        },
        setServicePolicyUrl() {
            privacyPolicyAgreementAction.getPrivacyPolicyStatuses()
                .then(result => {
                    this.servicePolicyUrl = result.servicePolicy.url
                })
        },
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImageUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/' + imgName)
        }
    },
}
</script>

<style scoped lang="scss">
@use '../../../scss/v2/base/variables';
@use "sass:math";
$grid-base: 4.27vw; // 375px幅に対して16px
$grid-consistent: $grid-base * 0.5; // 375px幅に対して8px

.c-panel-primary {
    background-color: variables.$color-pictlink-pink-10;
    border-radius: $grid-base;
    margin-top: $grid-consistent * 1.5;

    .m-text-link {
        text-decoration: none;
    }

    &-line {
        height: 2px;
        background-color: variables.$color-pictlink-pink;
        width: $grid-base * 6;
        border: none;
        margin: 7px auto;
    }

    &-arrow::after {
        content: " ";
        position: relative;
        display: inline-block;
        width: $grid-consistent;
        height: $grid-base;
        background-image: url(/img/jhs_free/arrow.png);
        background-size: contain;
        margin-left: 6px;
        vertical-align: middle;
    }
}

.c-heading-appeal-wrap {
    position: relative;
    :deep(.m-heading-primary) {
        line-height: 1;
    }
    .c-illust-girl-img {
        position: absolute;
        right: math.div($grid-consistent, 2);
        top: 10%;
        transform: translateY(-50%);
        width: 76px;
    }
}

.c-gray-panel {
    padding: $grid-consistent $grid-consistent * 2 $grid-consistent $grid-consistent * 4;
    border: 1px solid variables.$color-pictlink-fog-25;
    background: variables.$color-offwhite;
    >ol >li {
        list-style: decimal;
    }
    .m-list-text-item {
        font-weight: normal;
        margin-bottom: math.div($grid-consistent, 2);
    }
    .c-gray-panel-caution {
        position: relative;
        span {
            position: absolute;
            top: 0;
            left: -1.4rem;
        }
    }
}

</style>
